import {
  Checkbox,
  Chip,
  createStyles,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core'
import * as R from 'ramda'
import React from 'react'

import { sortStrings } from '../../../services/sortingService'

interface MultiSelectDropDownProps extends WithStyles<typeof styles> {
  fullList: string[]
  currentValues: string[]
  onSchoolsSelect: (schools: string[]) => void
}

const CustomMultiSelectDropDown: React.FC<MultiSelectDropDownProps> = (props: MultiSelectDropDownProps) => {
  const {
    classes,
    currentValues,
    fullList,
    onSchoolsSelect
  } = props

  const handleSchoolsSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (Array.isArray(e.target.value)) onSchoolsSelect(e.target.value)
  }

  const handleDelete = (name: string) => () => {
    onSchoolsSelect(R.without([name], currentValues))
  };

  return (
    <Grid container={true} spacing={8} className={classes.root}>
      <Grid item={true} xs={12} sm={6} md={3} className={classes.label}>
        Schools, if applicable:
      </Grid>
      <Grid item={true} xs={12} md={9}>
        <FormControl className={classes.formControl} required={true}>
          {R.isEmpty(currentValues) &&
            <InputLabel id="select-school-checkbox" style={{ paddingLeft: '.75rem' }}> Select school(s)</InputLabel>}
          <Select
            multiple={true}
            value={sortStrings(R.uniq(currentValues))}
            onChange={handleSchoolsSelect}
            input={
              <OutlinedInput id="select-school-checkbox" labelWidth={0} required={true} className={classes.input}/>
            }
            renderValue={selected => {
              if (Array.isArray(selected)) {
                if (selected.length === 0) {
                  return <em>Select school(s)</em>;
                }

                return selected.join(', ');
              }

              return []
            }}
          >
            {fullList.map(school => (
              <MenuItem key={school} value={school}>
                <Checkbox checked={currentValues.indexOf(school) > -1} />
                <ListItemText primary={school} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item={true} xs={false} md={3}/>
      <Grid item={true} xs={12} md={9}>
        {
          sortStrings(R.uniq(currentValues)).map(name => (
            <Chip
              label={name}
              onDelete={handleDelete(name)}
              color="primary"
              variant="outlined"
              key={name}
              classes={{ deleteIconOutlinedColorPrimary: classes.icon }}
              className={classes.chip}
            />
          ))
        }
      </Grid>
    </Grid>
  )
}

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    label: {
      justifyContent: 'flex-end',
      display: 'flex',
      paddingRight: '8px',
      alignItems: 'center',

      [theme.breakpoints.down('sm')]: {
        flexBasis: '100%',
        justifyContent: 'flex-start',
      },
    },
    formControl: {
      width: '100%'
    },
    textField: {},
    input: {
      paddingLeft: '10px',
    },
    select: {},
    icon: {
      color: '#e57373',
      '&:hover': {
        color: 'red',
      }
    },
    chip: {
      margin: '0 3px 3px 0'
    }
  })

export default withStyles(styles)(CustomMultiSelectDropDown)
